export const stripQueryParams = (url) => {
  const [path] = url.split('?');
  return path;
};
